import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Wie lange dauert der Prozess?",
    a: "Die kostenfreie Vorab-Rückmeldung erhalten Sie innerhalb von 24 Stunden. Nach der Einreichung der Meldung hängt die Bearbeitungszeit ausschließlich von der jeweiligen Plattform ab und kann von einigen Tagen bis zu mehreren Wochen variieren.",
  },
  {
    q: "Was passiert, wenn die Bewertung nicht entfernt wird?",
    a: "Sollte die Plattform die Entfernung ablehnen, gibt es in der Regel keine Möglichkeit, die Entscheidung anzufechten – die finale Entscheidung liegt bei der Plattform. Es entstehen Ihnen jedoch keine weiteren Kosten.",
  },
  {
    q: "Welche Informationen muss ich bereitstellen?",
    a: "Sie benötigen lediglich den direkten Link zur Bewertung und so viele Hintergrund­informationen, wie sie für eine Meldung über das offizielle Plattform-Formular relevant sind (z. B. Kundendaten, Details zur Situation).",
  },
  {
    q: "Was kostet die Dienstleistung?",
    a: "Ich arbeite mit transparenten Festpreisen. Die genauen Kosten teile ich Ihnen nach meiner kostenfreien Vorab-Rückmeldung mit. Es gibt keine versteckten Gebühren. Die Vorab-Rückmeldung ist immer kostenlos und unverbindlich.",
  },
  {
    q: "Ist das rechtlich zulässig?",
    a: "Ja. Die Meldung von Bewertungen, die gegen die Richtlinien von Google oder geltendes Recht verstoßen, ist ein legitimer Prozess. Meine Dienstleistung beschränkt sich auf die administrative Unterstützung bei der strukturierten Aufbereitung und Einreichung einer Meldung gemäß den jeweiligen Plattform-Vorgaben. Ich erbringe keine Rechtsberatung und keine juristische Vertretung. Sollte in Einzelfällen eine juristische Bewertung erforderlich sein, kann auf Wunsch ein externer Rechtsanwalt hinzugezogen werden.",
  },
  {
    q: "Garantieren Sie die Löschung einer Bewertung?",
    a: "Nein. Ich verspreche ausdrücklich keine garantierte Löschung. Meine Leistung besteht darin, Ihre Meldung strukturiert aufzubereiten und über die offiziellen Meldewege einzureichen. Die Entscheidung über eine Entfernung liegt ausschließlich bei der jeweiligen Plattform.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 lg:py-28 border-t border-black/[0.05]">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">Häufige Fragen</div>
        <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
          Antworten auf die wichtigsten Fragen.
        </h2>
        <p className="mt-5 text-[#6b5f52]">
          Finden Sie hier die häufigsten Fragen rund um den Meldeprozess von Online-Bewertungen.
        </p>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="border border-black/[0.08] rounded-2xl px-6 bg-[#faf6ef] data-[state=open]:border-[#2b2620]/40 transition-colors"
            >
              <AccordionTrigger className="text-left font-heading text-base sm:text-lg font-medium text-[#2b2620] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#6b5f52] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
